import { NonEmptyArray } from 'fp-ts/NonEmptyArray';
import * as React from 'react';
import { FeatherIcon } from '../../../components/FeatherIcon';
import { MatchEventFragmentFragment, Player } from '../../../generated/graphql';

interface Props {
  playerEvents: NonEmptyArray<MatchEventFragmentFragment>;
  onRemoveEvent: (id: string) => void;
  getButtonText: (player: Pick<Player, 'id' | 'name'>) => string;
}

export const PlayerEventEditList: React.FunctionComponent<Props> = ({
  playerEvents,
  onRemoveEvent,
  getButtonText,
}) => {
  return (
    <ul className="space-y-2">
      {playerEvents.map((playerEvent) => (
        <li key={playerEvent.id} className="flex items-center">
          <p>{playerEvent.player.name}</p>
          <button
            onClick={() => onRemoveEvent(playerEvent.id)}
            className="pointer ml-auto text-grey-500 hover:text-grey-800"
            title={getButtonText(playerEvent.player)}
          >
            <FeatherIcon icon="x" />
          </button>
        </li>
      ))}
    </ul>
  );
};
